import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getPunditPurohitAuthHeaders, getStoredPunditPurohitUser } from '../utils/auth';

const SubscriptionModal = ({ open, onClose, title = 'Annual Pooja Subscriptions' }) => {
  const [plans, setPlans] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [selectedCode, setSelectedCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [subscriptionFlowEnabled, setSubscriptionFlowEnabled] = useState(false);
  const apiBase = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!open) return;
    const savedUser = getStoredPunditPurohitUser();
    setUser(savedUser);

    axios
      .get(`${apiBase}/api/punditpurohit/checkout-settings`)
      .then((res) => setSubscriptionFlowEnabled(Boolean(res.data?.subscriptionFlowEnabled)))
      .catch((err) => {
        console.error('Unable to load subscription settings', err);
        setSubscriptionFlowEnabled(false);
      });

    axios
      .get(`${apiBase}/api/punditpurohit/subscription-plans`)
      .then((res) => {
        setPlans(res.data);
        setSelectedCode('');
      })
      .catch((err) => {
        console.error('Unable to fetch subscription plans', err);
        setPlans([]);
      });

    if (savedUser) {
      axios
        .get(`${apiBase}/api/punditpurohit/subscriptions/current`, { headers: getPunditPurohitAuthHeaders() })
        .then((res) => setCurrentSubscription(res.data))
        .catch(() => setCurrentSubscription(null));
    } else {
      setCurrentSubscription(null);
    }
  }, [apiBase, open]);

  if (!open || !subscriptionFlowEnabled) return null;

  const selectedPlan = plans.find((plan) => plan.code === selectedCode);
  const currentAmount = Number(currentSubscription?.amount_paid || 0);

  const subscribe = () => {
    if (!user) {
      window.dispatchEvent(new CustomEvent('pp-open-auth', { detail: { mode: 'signin' } }));
      return;
    }
    if (!selectedPlan) return;

    setLoading(true);
    axios
      .post(`${apiBase}/api/punditpurohit/subscriptions`, { planCode: selectedPlan.code }, { headers: getPunditPurohitAuthHeaders() })
      .then(() => {
        alert('Subscription activated. Confirmation email sent.');
        onClose?.();
      })
      .catch((err) => alert(err?.response?.data?.message || 'Unable to activate subscription.'))
      .finally(() => setLoading(false));
  };

  return (
    <div className="modal-overlay">
      <div className="subscription-modal">
        <div className="subscription-modal-header">
          <div>
            <h3>{title}</h3>
            {currentSubscription && (
              <p className="subscription-current">
                Current plan: {currentSubscription.plan_name} until {new Date(currentSubscription.end_date).toLocaleDateString()}
              </p>
            )}
          </div>
          <button className="close-drawer" onClick={onClose}>Close</button>
        </div>

        <div className="subscription-plan-grid">
          {plans.map((plan) => {
            const isUnavailable = currentSubscription && Number(plan.annualPrice) <= currentAmount;
            return (
              <button
                key={plan.code}
                type="button"
                className={`subscription-plan-card ${selectedCode === plan.code ? 'active' : ''} ${isUnavailable ? 'disabled' : ''}`}
                onClick={() => !isUnavailable && setSelectedCode(plan.code)}
                disabled={isUnavailable}
              >
                <span>{plan.name}</span>
                <strong>${plan.annualPrice}</strong>
                <p>{plan.monthlyPoojaCredits} free pooja{plan.monthlyPoojaCredits > 1 ? 's' : ''} per month</p>
                {isUnavailable && (
                  <p className="subscription-plan-note">
                    {plan.code === currentSubscription?.plan_code ? 'Current plan' : 'Lower plan'}
                  </p>
                )}
                <ul>
                  {(plan.benefits || []).map((benefit) => <li key={benefit}>{benefit}</li>)}
                </ul>
              </button>
            );
          })}
        </div>

        <button className="login-submit-btn" disabled={!selectedPlan || loading} onClick={subscribe}>
          {loading ? 'Processing...' : currentSubscription ? 'Upgrade Subscription' : 'Subscribe Now'}
        </button>
      </div>
    </div>
  );
};

export default SubscriptionModal;
